// extracted by mini-css-extract-plugin
module.exports = {"sectionInfo":"intro_sectionInfo__2cdpH","fakecard":"intro_fakecard__1FDbT","buttonBlack":"intro_buttonBlack__1vfU_","sectionTitle":"intro_sectionTitle__1iyqG"};